export default __webpack_public_path__ + "static/media/p-2.fa582801.png";